import { useState, useEffect, useCallback } from 'react'
import { API_BASE_URL } from '../../lib/config'
import { LLM_CONFIG_CHAT_MODELS, type LlmConfigChatModelOption } from './llmConfigModels'

export type AvailableChatModel = LlmConfigChatModelOption

export function useAvailableChatModels() {
  const [models, setModels] = useState<AvailableChatModel[]>(() => [...LLM_CONFIG_CHAT_MODELS])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API_BASE_URL}chat/available-models`, {
        credentials: 'include',
      })
      if (!res.ok) {
        setModels([...LLM_CONFIG_CHAT_MODELS])
        return
      }
      const data = (await res.json()) as { models?: { id: string; label: string }[] }
      const list = data.models?.filter((m) => m.id && m.label) ?? []
      setModels(list.length > 0 ? list : [...LLM_CONFIG_CHAT_MODELS])
    } catch {
      setModels([...LLM_CONFIG_CHAT_MODELS])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  return { models, loading, refetch: load }
}
